/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from './app.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from './layout/navigation.component.ngfactory';
import * as import3 from '../../../src/app/layout/navigation.component';
import * as import4 from '../../../src/app/shared/services/auth.service';
import * as import5 from '@angular/common';
import * as import6 from '@angular/router';
import * as import7 from '../../../src/app/shared/services/window-ref.service';
import * as import8 from '../../../src/app/shared/services/user.service';
import * as import9 from './home/home.component.ngfactory';
import * as import10 from '../../../src/app/home/home.component';
import * as import11 from '../../../src/app/app.component';
import * as import12 from '@angular/platform-browser';
const styles_AppComponent:any[] = [import0.styles];
export const RenderType_AppComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_AppComponent,
  data: {}
}
);
function View_AppComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'my-navigation-layout',([] as any[]),(null as any),(null as any),(null as any),import2.View_NavigationLayoutComponent_0,import2.RenderType_NavigationLayoutComponent)),
    import1.ɵdid(57344,(null as any),0,import3.NavigationLayoutComponent,[
      import4.AuthService,
      import5.Location,
      import6.Router,
      import7.WindowRefService,
      import8.UserService
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n  ']))
  ]
  ,(ck,v) => {
    ck(v,3,0);
  },(null as any));
}
function View_AppComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'my-home',([] as any[]),(null as any),(null as any),(null as any),import9.View_HomeComponent_0,import9.RenderType_HomeComponent)),
    import1.ɵdid(57344,(null as any),0,import10.HomeComponent,[import4.AuthService],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
function View_AppComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'button',[[
        'ngClass',
        'scrollTop'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.scrollToTop(500)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(139264,(null as any),0,import5.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),[' '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-chevron-up'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any)))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'scrollTop';
    ck(v,1,0,currVal_0);
  },(null as any));
}
export function View_AppComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵted((null as any),['  '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),1,(null as any),View_AppComponent_1)),
    import1.ɵdid(8192,(null as any),0,import5.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),1,(null as any),View_AppComponent_2)),
    import1.ɵdid(8192,(null as any),0,import5.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(8388608,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(73728,(null as any),0,import6.RouterOutlet,[
      import6.RouterOutletMap,
      import1.ViewContainerRef,
      import1.ComponentFactoryResolver,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),1,(null as any),View_AppComponent_3)),
    import1.ɵdid(8192,(null as any),0,import5.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n']))
  ]
  ,(ck,v) => {
    var co:import11.AppComponent = v.component;
    const currVal_0:any = co.detectUrl();
    ck(v,2,0,currVal_0);
    const currVal_1:boolean = (!co.authService.loggedin && co.authService.appLoader);
    ck(v,5,0,currVal_1);
    const currVal_2:any = co.showHide;
    ck(v,11,0,currVal_2);
  },(null as any));
}
function View_AppComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'my-app',([] as any[]),(null as any),[[
        'window',
        'scroll'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('window:scroll' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).doSomething($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_AppComponent_0,RenderType_AppComponent)),
    import1.ɵdid(57344,(null as any),0,import11.AppComponent,[
      import4.AuthService,
      import8.UserService,
      import5.Location,
      import7.WindowRefService,
      import12.Title
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:import1.ComponentFactory<import11.AppComponent> = import1.ɵccf('my-app',import11.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3RtcC9zd2lmdC1idWlsZC9wcm9kL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy90bXAvc3dpZnQtYnVpbGQvcHJvZC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy90bXAvc3dpZnQtYnVpbGQvcHJvZC9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3RtcC9zd2lmdC1idWlsZC9wcm9kL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCIgIDxkaXYgKm5nSWY9XCJkZXRlY3RVcmwoKVwiPlxuICAgIDxteS1uYXZpZ2F0aW9uLWxheW91dD48L215LW5hdmlnYXRpb24tbGF5b3V0PlxuICA8L2Rpdj5cbiAgPG15LWhvbWUgKm5nSWY9XCIhYXV0aFNlcnZpY2UubG9nZ2VkaW4gJiYgYXV0aFNlcnZpY2UuYXBwTG9hZGVyXCI+PC9teS1ob21lPlxuICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG4gIDxidXR0b24gKm5nSWY9XCJzaG93SGlkZVwiIChjbGljayk9XCJzY3JvbGxUb1RvcCg1MDApXCIgbmdDbGFzcz1cInNjcm9sbFRvcFwiPiA8c3Bhbj48aSBjbGFzcz1cImZhIGZhLWNoZXZyb24tdXBcIiBhcmlhLWhpZGRlbj1cInRydWVcIj48L2k+PC9zcGFuPjwvYnV0dG9uPlxuXG4iLCI8bXktYXBwPjwvbXktYXBwPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0FFO0lBQXlCO0lBQ3ZCO2dCQUFBOzs7Ozs7SUFBQTtLQUFBO0lBQTZDOzs7SUFBN0M7Ozs7O0lBRUY7Z0JBQUE7OztJQUFBOzs7OztNQUVBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7TUFBeUI7UUFBQTtRQUFBO01BQUE7TUFBekI7SUFBQTtnQkFBQTs7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBd0U7SUFBQztJQUFNO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTs7O0lBQTNCO0lBQXBELFNBQW9ELFNBQXBEOzs7OztJQUxGO0lBQUU7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUVNO0lBQ047Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEwRTtJQUMxRTtnQkFBQTs7OztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFBK0I7SUFDL0I7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFrSjs7OztJQUw3STtJQUFMLFNBQUssU0FBTDtJQUdTO0lBQVQsU0FBUyxTQUFUO0lBRVE7SUFBUixVQUFRLFNBQVI7Ozs7O01DTEY7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtJQUFBO2dCQUFBOzs7Ozs7SUFBQTtLQUFBOzs7SUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/src/app/app.component.ngfactory.ts